<template>
  <LayoutDefault>
    <ModulesList/>
    <AchievementsEditorView v-if="showAchievementsEditor"/>
    <RegionsEditorView v-if="showRegionsEditorView"/>
  </LayoutDefault>
</template>

<script>
import { computed } from 'vue'
import { useStore } from 'vuex'

import LayoutDefault from '@/layout/LayoutDefault'
import ModulesList from '@/components/blocks/ModulesList'
import AchievementsEditorView from '@/views/siteModules/AchievementsEditorView'
import RegionsEditorView from '@/views/siteModules/RegionsEditorView'

export default {
  name: 'ModulesView',
  components: {
    LayoutDefault,
    ModulesList,
    AchievementsEditorView,
    RegionsEditorView
  },
  props: {
  },
  setup () {
    const store = useStore()

    const showAchievementsEditor = computed(() => store.getters.getShowAchievementsEditor)
    const showRegionsEditorView = computed(() => store.getters.getShowRegionsEditorView)

    return {
      showAchievementsEditor,
      showRegionsEditorView
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
